import { useRef } from 'react';
import { useIsomorphicEffect } from './useIsomorphicEffect';

/** It will let you know if current component is mounted or not... it returns a ref and not a state */
export function useMountedRef() {
  const mounted = useRef(false);
  // unmount before render cycle
  useIsomorphicEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return mounted;
}
